module.exports = __webpack_public_path__ + "static/media/logo_80_ss.27f0b9ff.png";